/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_AddInputs */

const cs_contracts_add = /** @type {(inputs: Contracts_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat smlouvu`)
};

const en_contracts_add = /** @type {(inputs: Contracts_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add contract`)
};

/**
* | output |
* | --- |
* | "Add contract" |
*
* @param {Contracts_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_add = /** @type {((inputs?: Contracts_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_add(inputs)
	return cs_contracts_add(inputs)
});